'use client';
import { Link } from 'react-router-dom';
import { useStore } from '../../stores/root-store-context';
import { useTranslation } from 'react-i18next';
import { ApiOutlined } from '@ant-design/icons';
import { Roles } from '../../enums/Roles';

export default function MobileMenu() {
  const { t } = useTranslation();
  const { applicationStore } = useStore();

  const isOwnerOrFinancier = applicationStore.user?.roles?.some((r) =>
    [Roles.Owner, Roles.Financier].includes(r.id)
  );

  return (
    <div className="mobile-menu fix mb-3 mean-container">
      <div className="mean-bar">
        <Link
          to="/#nav"
          className="meanmenu-reveal"
          style={{ right: 0, left: 'auto', display: 'inline' }}
        >
          <span>
            <span>
              <span />
            </span>
          </span>
        </Link>

        <nav className="mean-nav">
          {/* ───────────────────── GUEST LINKS ───────────────────── */}
          {!applicationStore.isAuthenticated ? (
            <ul>
              <li>
                <Link to="/login">{t('SignIn')}</Link>
              </li>
              <li>
                <Link to="/AboutCompany">{t('Menu.AboutUs')}</Link>
              </li>
              <li>
                <Link to="/prices">{t('Menu.Prices')}</Link>
              </li>
              <li>
                <Link to="/api-list">
                  {t('API')} <ApiOutlined style={{ marginRight: 5 }} />
                </Link>
              </li>
              <li>
                <Link to="/register-company">{t('RegisterCompany')}</Link>
              </li>
            </ul>
          ) : (
            /* ──────────────────── AUTH LINKS ──────────────────── */
            <ul>
              <li>
                <Link to={`/${applicationStore.company?.Tenant}`}>
                  {t('Menu.MyCompany')}
                </Link>
              </li>
              <li>
                <Link to={`/${applicationStore.company?.Tenant}/employees`}>
                  {t('Menu.Employees')}
                </Link>
              </li>
              <li>
                <Link to={`/${applicationStore.company?.Tenant}/projects`}>
                  {t('Menu.Projects')}
                </Link>
              </li>
              <li>
                <Link to={`/${applicationStore.company?.Tenant}/tests`}>
                  {t('Menu.Tests')}
                </Link>
              </li>
              <li>
                <Link to={`/${applicationStore.company?.Tenant}/time-reports/Calendar`}>
                  {t('Calendar')}
                </Link>
              </li>
              <li>
                <Link to={`/${applicationStore.company?.Tenant}/time-reports`}>
                  {t('Menu.TimeEvents')}
                </Link>
              </li>
              {isOwnerOrFinancier && (
                <li>
                  <Link to={`/${applicationStore.company?.Tenant}/employees/salaries`}>
                    {t('Menu.Salaries')}
                  </Link>
                </li>
              )}
            </ul>
          )}
        </nav>
      </div>
    </div>
  );
}
